module.exports = __webpack_public_path__ + "img/shield-fill-exclamation.14e03f86.svg";